import emptyImage from '@/images/emptyImage.png'
export function getImageFullUrl(path?: string): string {
  if (!path) return emptyImage
  if (path.startsWith('https://')) return path

  const base = import.meta.env.VITE_FILE_URL

  return `${base}/${path}`
}
